export { ErrorMessage, HelperMessage, Label, RequiredAsterisk } from '@atlaskit/form';
import { Pressable, xcss, Text, Inline } from '@atlaskit/primitives';
import TextArea from '@atlaskit/textarea';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';
import React from 'react';
import styled from 'styled-components';

export const SeamlessTextfield = styled(Textfield)`
  margin-left: ${token('space.100', '8px')};
  &&:not(:hover) {
    background-color: transparent;
  }

  &&:not(:focus-within) {
    border-color: transparent;
  }
`;

export const SeamlessTextArea = styled(TextArea)`
  &&:not(:hover) {
    background-color: transparent;
  }

  &&:not(:focus-within) {
    border-color: transparent;
  }
`;

/**
 * Renders a button with 100% width and particular spacing that is more aligned with forms.
 * The spacing will make sure that the icon is aligned with checkboxes and other form elements.
 */

const formButtonStyles = xcss({
  display: 'flex',
  height: '36px',
  alignItems: 'center',
  paddingInline: 'space.200',
  paddingBlock: 'space.075',
  gap: 'space.100',
  backgroundColor: 'color.background.neutral.subtle',
  color: 'color.text',
  width: '100%',

  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered',
  },
  ':active': {
    backgroundColor: 'color.background.neutral.subtle.pressed',
  },
});

export function FormButton({
  iconBefore,
  text,
  onClick,
  testId,
}: {
  iconBefore?: React.ReactNode;
  text?: string;
  onClick?: () => void;
  testId?: string;
}) {
  return (
    <Pressable xcss={formButtonStyles} onClick={onClick} testId={testId}>
      {iconBefore}
      <Text size="medium">{text}</Text>
    </Pressable>
  );
}

export const ToggleContainer = ({ children }: { children: React.ReactNode }) => (
  <Inline alignBlock="center" spread="space-between">
    {children}
  </Inline>
);
